import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

//component root
import { ThankYouComponent } from "./thank-you.component";
//routes
import { ThankYouRoutes as routes } from "./thank-you.routes";
import {ModalModule} from "ngx-modal";

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    ModalModule
  ],
  exports:[
      ThankYouComponent
  ],
  declarations: [ThankYouComponent]
})
export class ThankYouModule { }
